import { Popover, PopoverOrigin } from '@material-ui/core';
import { Dictionary } from '@models/common';
import * as React from 'react';

export const SwyftPopoverContent = ({ children }: { children: (onClose: () => void) => React.ReactNode }) => (
  <React.Fragment>{children}</React.Fragment>
);

export const SwyftPopover = ({
  children,
  className = '',
  callbackParent,
  disabled = false,
  anchorOrigin,
  transformOrigin
}: {
  children: React.ReactNode;
  className?: string;
  callbackParent?: () => void;
  disabled?: boolean;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
}) => {
  const [anchorEl, setAnchorEl] = React.useState<any>(null);
  const open = Boolean(anchorEl);

  const childs = React.Children.toArray(children);
  const parent = childs.find((c) => (c as any).type !== SwyftPopoverContent);
  const content = childs.find((c) => typeof (c as any).type === 'function');

  const openPopover = (event: React.MouseEvent) => {
    if (!disabled) setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (callbackParent) callbackParent();
  };

  return (
    <React.Fragment>
      <div onClick={openPopover}>{parent}</div>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={
          anchorOrigin
            ? anchorOrigin
            : {
                vertical: 'bottom',
                horizontal: 'center'
              }
        }
        transformOrigin={
          transformOrigin
            ? transformOrigin
            : {
                vertical: 'top',
                horizontal: 'center'
              }
        }
        className={className}
      >
        {content ? (content as any).props.children(handleClose) : null}
      </Popover>
    </React.Fragment>
  );
};
